import helpers from "../../helper/helpers";

export default (tracking, pageData, callback) => {
    window.utag_cfg_ovrd = {noview: true};
    let init = function (a, b, c, d) {
        a = `//tags.tiqcdn.com/utag/telenor/${tracking.tealium_profile || 'telenor.no'}/${tracking.tealium_env || 'prod'}/utag.js`;
        b = document;
        c = 'script';
        d = b.createElement(c);
        d.src = a;
        d.type = 'text/javascript';
        d.async = true;
        a = b.getElementsByTagName(c)[0];
        a.parentNode.insertBefore(d, a);
        d.onload = function () {
            if (!d.onloadDone) {
                d.onloadDone = true;
                callback(tracking, pageData);
            }
        };
        d.onreadystatechange = function () {
            if ((d.readyState === 'loaded' || d.readyState === 'complete') && !d.onloadDone) {
                d.onloadDone = true;
                callback(tracking, pageData);
            }
        };
    };
    helpers.onLoad(() => init());
}